import { render, staticRenderFns } from "./CustomReport.vue?vue&type=template&id=c6a1f6e6&"
import script from "./CustomReport.vue?vue&type=script&lang=js&"
export * from "./CustomReport.vue?vue&type=script&lang=js&"
import style0 from "./CustomReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports